import React from 'react';
import { Route, Switch } from 'react-router-dom';
import {
  ADMINISTRATIVE_CHECKLIST_PATH,
  AGENCY_INCIDENT_PATH,
  ITINERARY_INCIDENT_PATH,
  NEW_ADMINISTRATIVE_CHECKLIST_PATH,
  NEW_AGENCY_INCIDENT_PATH,
  SUPERVISION_CONTROL_UNIT_PATH,
} from '../../../config/paths';
import SupervisionControlHome from './SupervisionControlHome';
import ItineraryIncidents from './itinerary-incident/ItineraryIncidents';
import ItineraryIncident from './itinerary-incident/ItineraryIncident';
import NewItineraryIncident from './itinerary-incident/NewItineraryIncident';
import ItineraryIncidentRecord from './itinerary-incident/ItineraryIncidentRecord';
import NewAdministrativeChecklist from './itinerary-incident/NewAdministrativeChecklist';
import AgencyIncidents from './itinerary-incident/AgencyIncidents';
import NewAgencyIncident from './itinerary-incident/NewAgencyIncident';
import AgencyIncidentRecord from './itinerary-incident/AgencyIncidentRecord';
import AdministrativeChecklists from './itinerary-incident/AdministrativeChecklists';
import AdministrativeCheckList from './itinerary-incident/AdministrativeChecklist';

const SupervisionControlUnit = () => (
  <Switch>
    <Route
      exact
      path={SUPERVISION_CONTROL_UNIT_PATH}
      component={SupervisionControlHome}
    />
    <Route
      exact
      path={ITINERARY_INCIDENT_PATH}
      component={ItineraryIncidents}
    />
    <Route
      exact
      path={`${ITINERARY_INCIDENT_PATH}/:id`}
      component={ItineraryIncident}
    />
    <Route exact path={AGENCY_INCIDENT_PATH} component={AgencyIncidents} />
    <Route
      exact
      path={`${ITINERARY_INCIDENT_PATH}/itinerary/:itineraryId/segment/:segmentId`}
      component={ItineraryIncident}
    />
    <Route
      exact
      path={`${ITINERARY_INCIDENT_PATH}/itinerary/:itineraryId/segment/:segmentId/new`}
      component={NewItineraryIncident}
    />
    <Route
      exact
      path={NEW_AGENCY_INCIDENT_PATH}
      component={NewAgencyIncident}
    />
    <Route
      exact
      path={`${AGENCY_INCIDENT_PATH}/:incidentRecordId`}
      component={AgencyIncidentRecord}
    />
    <Route
      exact
      path={`${ITINERARY_INCIDENT_PATH}/itinerary/:itineraryId/segment/:segmentId/incident-record/:incidentRecordId`}
      component={ItineraryIncidentRecord}
    />
    <Route
      exact
      path={ADMINISTRATIVE_CHECKLIST_PATH}
      component={AdministrativeChecklists}
    />
    <Route
      exact
      path={NEW_ADMINISTRATIVE_CHECKLIST_PATH}
      component={NewAdministrativeChecklist}
    />
    <Route
      exact
      path={`${ADMINISTRATIVE_CHECKLIST_PATH}/:incidentRecordId`}
      component={AdministrativeCheckList}
    />
  </Switch>
);

export default SupervisionControlUnit;
